import { Dropdown, Menu } from "antd";
import React from "react";

const ActionDropdown = ({ items, onDropDown, placement, onEdit, onDelete, overlay }) => {
  // If overlay is provided, use it directly (for custom menu)
  if (overlay) {
    return (
      <div onClick={(e) => e.stopPropagation()} className="cursor-pointer">
        <Dropdown overlay={overlay} trigger={["click"]} placement={placement}>
          <div className="actionIconsSprite editDeleteSettingsIcon cursor-pointer" data-cy="action-dropdown-trigger" />
        </Dropdown>
      </div>
    );
  }

  // If onEdit/onDelete are provided, create menu using Menu component (consistent with Templates pattern)
  if (onEdit || onDelete) {
    const menu = (
      <Menu>
        {onEdit && (
          <Menu.Item
            key="edit"
            onClick={(e) => {
              onEdit(e);
            }}
          >
            <div className="actionIconsSprite editTemplate-icon" data-cy="edit-action">
              <span className="ps-4 hs-fs-12">Edit</span>
            </div>
          </Menu.Item>
        )}
        {onDelete && (
          <Menu.Item
            key="delete"
            onClick={(e) => {
              onDelete(e);
            }}
          >
            <div className="actionIconsSprite deleteTemplate-icon" data-cy="delete-action">
              <span className="ps-4 hs-fs-12">Delete</span>
            </div>
          </Menu.Item>
        )}
      </Menu>
    );

    return (
      <div onClick={(e) => e.stopPropagation()} className="cursor-pointer">
        <Dropdown overlay={menu} trigger={["click"]} placement={placement} rootClassName="editDeleteSettingDropdown">
          <div className="actionIconsSprite editDeleteSettingsIcon cursor-pointer" data-cy="action-dropdown-trigger" />
        </Dropdown>
      </div>
    );
  }

  // Fallback to original behavior with items prop
  return (
    <div onClick={(e) => e.stopPropagation()} className="cursor-pointer">
      <Dropdown onClick={onDropDown} menu={{ items }} trigger={["click"]} placement={placement}>
        <div className="kebabMenuIcon call-action-icons" data-cy="action-dropdown-trigger" />
      </Dropdown>
    </div>
  );
};

export default ActionDropdown;
